import { useCallback } from 'react';
import { CHARGING, PROTECTION } from '../utils/constants';
const useCheckConfigureBapSectionAvailability = (protectionData, accessoriesData) => {
    const { areProtectionsAvailable, isDataLoaded: hasProtectionDataLoaded, isDataFailed: hasProtectionDataFailed, } = protectionData;
    const isProtectionsAvailable = hasProtectionDataLoaded ? areProtectionsAvailable : hasProtectionDataFailed;
    const isChargingAccessoriesAvailable = Boolean(accessoriesData === null || accessoriesData === void 0 ? void 0 : accessoriesData.some(item => item.category.id.toLowerCase() === CHARGING));
    return useCallback((section) => {
        switch (section) {
            case PROTECTION:
                return isProtectionsAvailable;
            case CHARGING:
                return isChargingAccessoriesAvailable;
            default:
                return true;
        }
    }, [isProtectionsAvailable, isChargingAccessoriesAvailable]);
};
export default useCheckConfigureBapSectionAvailability;
